import { AMENITIES } from './constants'

export const hasChangedFilters = (currentFilters, filters) => {
  const pickFrom = currentFilters

  const picked = Object.keys(filters).reduce((pickFilter, objectKey) => {
    if (pickFrom[objectKey]) pickFilter = { ...pickFilter, [objectKey]: pickFrom[objectKey] }
    return pickFilter
  }, {})

  return JSON.stringify(filters) !== JSON.stringify(picked)
}

export function getAmenitiesWithFacets (facets) {
  return AMENITIES.reduce((acc, {
    id, text, category, path,
  }) => {
    const facetsById = facets[id]
    if (!facetsById) {
      return acc
    }
    acc[category] = [...acc[category] || [], {
      id, text: `${text} (${facetsById})`, path, facets: facetsById,
    }]
    return acc
  }, {})
}

export const getAmenityText = (amenityId) => AMENITIES.find((a) => a.id === amenityId)?.text

